import { render, staticRenderFns } from "./BrandingGallery.vue?vue&type=template&id=43839ac4"
import script from "./BrandingGallery.vue?vue&type=script&lang=js"
export * from "./BrandingGallery.vue?vue&type=script&lang=js"
import style0 from "./BrandingGallery.vue?vue&type=style&index=0&id=43839ac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports